import { MatSpinner } from '@angular/material/progress-spinner';
import { UserService } from './../service/user-service';
import { ChangeDetectionStrategy, Component, inject, Input, model, signal, ViewChild } from '@angular/core';
import { ListItem, ModalListItemI, Profil, Site, User } from '../../shared/model';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { ToastrService } from '../../shared/services/toastr-service';
import { SweetAlertService } from '../../shared/services/sweet-alert-service';
import { MatAnchor, MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { TitleComponent } from '../../shared/components/title-component/title-component';
import { SearchBarComponent } from '../../shared/components/search-bar-component/search-bar-component';
import { MatCardModule } from '@angular/material/card';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { JsonPipe, UpperCasePipe } from '@angular/common';
import { ProfilService } from '../../auth/services/profil-service';;
import {MatStepperModule} from '@angular/material/stepper';
import { confirmPassword } from '../../shared/validators';
import { ListModalComponent } from '../../shared/components/list-modal-component/list-modal-component';

export interface ModalDataI{
  title : string
  update ?: boolean
  collaborateur_list ?: boolean
  data ?: User
  site_id ?: string
}

@Component({
  selector: 'app-user-component',
  imports: [
    TitleComponent,
    SearchBarComponent,
    MatCardModule,
    MatPaginator,
    MatPaginatorModule,
    MatSort,
    MatSortModule,
    MatTableModule,
    MatAnchor,
    MatIconModule,
    MatTooltip,
    MatButtonModule,
    UpperCasePipe,
    MatSpinner
  ],
  templateUrl: './user-component.html',
  styleUrl: './user-component.css',
})
export class UserComponent {

  displayedColumns: string[] = ['id', 'name', 'profil', 'gender', 'adresse', 'status',  'site_name', 'groupe_name', 'actions'];
  dataSource!: MatTableDataSource<User>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  searchValue = signal<string>('')
  currentUser = signal<User>(new User())
  readonly dialog = inject(MatDialog);
  loading = false

  constructor(
    private toastr : ToastrService,
    private userService : UserService,
    private sweetAlert : SweetAlertService){
    // Assign the data to the data source for the table to render
    this.dataSource = new MatTableDataSource<User>([]);
  }

  ngOnInit(): void {
    this.loading = true
      this.userService.getAll().subscribe({
        next : (res) =>{
          console.log(res);
          this.dataSource.data = res
          this.loading = false
        },
        error : (err) =>{
          this.loading = false
        }
      })

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  /*openAddUserModal(){
    const data : ModalDataI = {
      title : 'Ajouter un utilisateur',
      data : new User(),
      site_id : this.site_id
    }

    const dialogRef = this.dialog.open(UserComponentModal, {
      width : '700px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : User) => {

      if (result?.id != undefined) {
        const data : User[] = []
        data.push(...this.dataSource.data)
        data.push(result)

        this.dataSource.data = data
        this.toastr.success("L'utilisateur "+ result.name + " à été ajouté")
      }
    });
  }*/

  openUpdateUserModal(user : User){
    this.currentUser.set(user)

    const data : ModalDataI = {
      title : "Modifier l'utilisateur " + user.name,
      update : true,
      data : this.currentUser()
    }

    const dialogRef = this.dialog.open(UserComponentModal, {
      width : '700px',
      height: 'fit-content',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : User) => {

      if (result?.id != undefined) {
        const i = this.dataSource.data.findIndex(item => item.id == result.id)
        const data = this.dataSource.data
        data[i] = result
        this.dataSource.data = data
        this.toastr.success("L'utilisateur "+ result.name + " à été modifie")
      }
    });
  }

  confirm(user : User){
    this.sweetAlert
    .confirm("Etez-vous sur de vouloir supprimer l'utilisateur "+ user.name)
    .then((res) =>{
      if(res.isConfirmed){
        this.userService.delete(user.id).subscribe({
          next : (r) =>{
            this.dataSource.data = this.dataSource.data.filter(item => item.id != user.id)
            this.sweetAlert.success('Suppression reussie', 2000)
          }
        })
      }
    })
  }

  onChange(user : User){
    const title = user.disable?'Activation':'Desactivation'
    const action = user.disable?'activer':'desactiver'
    this.sweetAlert.confirm("Etez-vous sur de vouloir "+ action +" l' utilisateur " + user.name)
    .then((res) =>{
      if(res.isConfirmed){
        this.userService.changeUserStatus(user.id).subscribe({
          next : (result) =>{

            const i = this.dataSource.data.findIndex(item => item.id == result.id)
            const data = this.dataSource.data
            data[i] = result
            this.dataSource.data = data

            this.sweetAlert.success('Operaton reussie', 2000)
          }
        })
      }
    })
  }

  applyFilter(event : string){

    this.searchValue.update(val => event)
    this.dataSource.filter = event.trim().toLocaleLowerCase()

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

}

@Component({
  selector: 'app-user-modal',
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatStepperModule,
    MatIcon
  ],
  templateUrl: './modal-user.html',
  styleUrl: './modal-user.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserComponentModal {
  readonly dialogRef = inject(MatDialogRef<UserComponentModal>);

  // recupere les donnees envoyes par le parent
  readonly inputData = inject<ModalDataI>(MAT_DIALOG_DATA);

  // retourne le donne vers le parent
  readonly site = model(this.inputData.data!);

  userForm : FormGroup = new FormGroup({})

  profil_liste = signal<Profil[]>([])

  isLinear = true

  readonly dialog = inject(MatDialog);

  constructor(
    private fb : FormBuilder,
    private userService : UserService,
    private toastr : ToastrService,
    private profilService : ProfilService
  ){

  }

  ngOnInit(): void {

    this.userForm = this.fb.group({
      userPersoInfo : this.fb.group({
        name : ['', [Validators.required]],
        gender : ['', [Validators.required]],
        adresse : ['', [Validators.required]],
        email : ['', Validators.email],
        tel : ['', [Validators.required]],
        profil_id : ['', [Validators.required]],
        profil_name : [{value : '', disabled:true}]
      }),
      userAccountInfo : this.fb.group({
        username : ['', [Validators.required]],
        password : this.fb.group({
          password : ['', [Validators.required, Validators.minLength(6)]],
          confirmPassword : ['', [Validators.required]]
        }, {validators : confirmPassword})
      }),
    })

    if(this.inputData.update) {
      const data = {
        userPersoInfo : this.inputData.data,
        userAccountInfo : {}
      }
      this.userForm.patchValue(data)
      this.userForm.get('userAccountInfo')?.get('username')?.clearValidators()
      this.userForm.get('userAccountInfo')?.get('password')?.get('password')?.clearValidators()
      this.userForm.get('userAccountInfo')?.get('password')?.get('confirmPassword')?.clearValidators()
    }

    this.profilService.getAll().subscribe((res) => this.profil_liste.update(val => res))
  }

  ngAfterViewInit(): void {
    this.userForm.patchValue(this.inputData?.data!)
    //this.userForm.get()
  }

  resetForm(){
    this.userForm.patchValue({
      name : '',
      gender : '',
      adresse : '',
      profil_id : '',
      profil_name : '',
      site_id : '',
    })
  }


  onAdd(){
    const data = this.userForm.get('userPersoInfo')?.value
    data['site_id'] = this.inputData.site_id
    data['username'] = this.userForm.get('userAccountInfo')?.get('username')?.value
    data['password'] = this.userForm.get('userAccountInfo')?.get('password')?.get('password')?.value

    console.log(data);

    this.userService.create(data).subscribe({
      next : (res) =>{
        this.dialogRef.close(res)
      },
      error : (err) =>{
         this.toastr.error("Une erreur est survenue ")
      },
    })
  }

  onUpdate(){

    const data = this.userForm.get('userPersoInfo')?.value;

    this.userService.update(data, this.inputData.data?.id??'').subscribe({
      next : (res) =>{
        this.dialogRef.close(res)
      },
      error : (err) =>{
         this.toastr.error("Une erreur est survenue ")
      },
    })
  }

  selectProfil(){
    const data : ModalListItemI = {
      title : 'Liste des profils',
      data : this.profil_liste()??[]
    }

    const dialogRef = this.dialog.open(ListModalComponent, {
      width : '600px',
      height: 'fit-content',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : false,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : ListItem) => {
     if (result.id != '') {
        let data = this.profil_liste()
        data = data.filter(item => item.id == result.id)
        this.userForm.get('userPersoInfo')?.get('profil_name')?.setValue(data[0].name)
        this.userForm.get('userPersoInfo')?.get('profil_id')?.setValue(data[0].id)
      }
    });

  }

  generateUsername(){
    let username = (this.userForm.get('userPersoInfo')?.get('name')?.value as string).trim().toLowerCase().replace(' ', '')

    if(username.length > 6)
      username = username.substring(0, 6)

    this.userForm.get('userAccountInfo')?.get('username')?.setValue(username)
  }

}


